import ExpandOnHover from "../shared/ExpandOnHover";

export default function EventCard({ title, description, imageUrl }) {
  return (
    <ExpandOnHover>
      <div style={{ width: "300px", margin: "0.5rem" }} className="card">
        <div className="card-image">
          <figure className="image">
            <img
              style={{
                aspectRatio: 1,
                objectFit: "cover",
              }}
              src={imageUrl}
              alt="Event"
            />
          </figure>
        </div>
        <div className="card-content">
          <h1 className="title">{title}</h1>
          <p>{description}</p>
        </div>
      </div>
    </ExpandOnHover>
  );
}
